module.exports = __webpack_public_path__ + "static/3A841E_1_0-1137ef447cd0d9ac67ff809ca5dd5d01.svg";